import { Maybe } from 'maybe-not';
import MessageBus from '../utility/message-bus';
import { IContactRecord } from '../types';

export default function pickContact(messageBus: MessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('pickContact')) {
        return;
    }

    return function(): Promise<IContactRecord> {
        return messageBus
            .sendRequest<IContactRecord>(
                `executeDynamicPlatformAPI`,
                Maybe.just({ functionName: 'pickContact', args: [] }).map(JSON.stringify)
            )
            .then(response => {
                return response.value;
            });
    };
}
